<template>
  <div class="invite_register_box">
    <div v-if="loading" class="loading_block">
      <i class="el-icon-loading loading_icon" />
      <span>正在生成邀请链接...</span>
    </div>
    <template v-else-if="showResult">
      <div class="result_block">
        <div class="qr_wrap">
          <canvas ref="qrCanvas" class="qr_canvas" />
        </div>
        <div class="link_row">
          <el-input :value="inviteUrl" readonly />
          <el-button type="primary" @click="copyLink">复制</el-button>
        </div>
        <div class="btn_row">
          <el-button
            type="primary"
            :disabled="!inviteUrl"
            @click="downloadQrCode"
          >
            下载二维码
          </el-button>
          <el-button @click="handleClose">关闭</el-button>
        </div>
      </div>
    </template>
    <div v-else class="error_block">
      <p>{{ errorMsg || "生成失败" }}</p>
      <div class="btn_row">
        <el-button type="primary" @click="fetchInvite">重试</el-button>
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { generateInvite } from "@/api/shipment";
import qrLogo from "@/assets/invite-qr-logo.png";

const QR_SIZE = 220;
const LOGO_SIZE = 48;

export default {
  name: "InviteRegister",
  data() {
    return {
      loading: false,
      showResult: false,
      errorMsg: "",
      inviteUrl: ""
    };
  },
  mounted() {
    this.fetchInvite();
  },
  methods: {
    fetchInvite() {
      this.loading = true;
      this.showResult = false;
      this.errorMsg = "";
      generateInvite({})
        .then(res => {
          if (res.status == 0) {
            const url =
              typeof res.data === "string"
                ? res.data
                : (res.data &&
                    (res.data.inviteUrl ||
                      res.data.url ||
                      res.data.inviteLink)) ||
                  "";
            if (!url) {
              this.errorMsg = "未返回邀请链接";
              this.$message({ message: this.errorMsg, type: "warning" });
              return;
            }
            this.inviteUrl = url;
            this.showResult = true;
            this.$message({ message: res.msg || "生成成功", type: "success" });
          } else {
            this.errorMsg = res.msg || "生成失败";
          }
        })
        .catch(() => {
          this.errorMsg = "生成失败，请稍后重试";
        })
        .finally(() => {
          // 先关掉 loading，再 nextTick 画码，否则 canvas 尚未挂载
          this.loading = false;
          if (this.showResult && this.inviteUrl) {
            this.$nextTick(() => {
              this.renderQrCode(this.inviteUrl);
            });
          }
        });
    },
    async renderQrCode(url) {
      const canvas = this.$refs.qrCanvas;
      if (!canvas) return;
      try {
        await QRCode.toCanvas(canvas, url, {
          errorCorrectionLevel: "H",
          width: QR_SIZE,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#ffffff"
          }
        });
        await this.drawCenterLogo(canvas);
      } catch (e) {
        this.$message({ message: "二维码生成失败", type: "error" });
      }
    },
    drawCenterLogo(canvas) {
      return new Promise((resolve, reject) => {
        const ctx = canvas.getContext("2d");
        const logo = new Image();
        logo.onload = () => {
          const cx = canvas.width / 2;
          const cy = canvas.height / 2;
          const r = LOGO_SIZE / 2;
          const pad = 4;
          ctx.beginPath();
          ctx.arc(cx, cy, r + pad, 0, Math.PI * 2);
          ctx.fillStyle = "#ffffff";
          ctx.fill();
          ctx.save();
          ctx.beginPath();
          ctx.arc(cx, cy, r, 0, Math.PI * 2);
          ctx.clip();
          ctx.drawImage(logo, cx - r, cy - r, LOGO_SIZE, LOGO_SIZE);
          ctx.restore();
          resolve();
        };
        logo.onerror = reject;
        logo.src = qrLogo;
      });
    },
    copyLink() {
      if (!this.inviteUrl) {
        this.$message({ message: "暂无邀请链接", type: "warning" });
        return;
      }
      const textarea = document.createElement("textarea");
      textarea.value = this.inviteUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({ message: "复制成功", type: "success", duration: 1500 });
    },
    downloadQrCode() {
      const canvas = this.$refs.qrCanvas;
      if (!canvas) {
        this.$message({ message: "暂无二维码", type: "warning" });
        return;
      }
      const eleLink = document.createElement("a");
      eleLink.download = "invite-qrcode.png";
      eleLink.href = canvas.toDataURL("image/png");
      eleLink.click();
      eleLink.remove();
    },
    handleClose() {
      this.$emit("cancelModel");
    }
  }
};
</script>

<style scoped>
.invite_register_box {
  padding: 24px 20px 16px;
}
.loading_block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  color: #606266;
  gap: 12px;
}
.loading_icon {
  font-size: 32px;
  color: #409eff;
}
.error_block {
  text-align: center;
  min-height: 120px;
  color: #606266;
}
.btn_row {
  text-align: center;
  margin-top: 16px;
}
.result_block {
  padding: 0 4px;
}
.link_row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}
.qr_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
}
.qr_canvas {
  width: 220px;
  height: 220px;
  border: 1px solid #ebeef5;
}
</style>
